import React, { Fragment } from 'react';
import { Card, CardBody, Col, Media } from 'reactstrap';
import { Link } from 'react-router-dom';
import { H1, P, Image } from '../../../AbstractElements';
import dashImg from '../../../assets/images/images.svg';
import { GetAdminRole } from 'Component/Common/GetAdminRole';

const Greeting = () => {
  const user = localStorage.getItem('USER');
  const name = user ? JSON.parse(user).name : '';
  const role = GetAdminRole(JSON.parse(user));

  return (
    <Fragment>
      <Col xl="12" md="12" className="dash-xl-100 box-col-12">
        <Card className="profile-greeting">
          <CardBody>
            <Media>
              <Media body>
                <div className="greeting-user">
                  <H1>Hello, {role === 'super_admin' ? 'Super Admin' : role === 'admin' ? 'Admin' : 'Customer Service'}</H1>
                  <P>Welcome back {name}, your dashboard is ready!</P>
                  <Link to={`${process.env.PUBLIC_URL}/clinics`} className="btn btn-outline-white_color" >
                    Go to Clinics<i className="icon-arrow-right"></i>
                  </Link>
                </div>
              </Media>
            </Media>
            <div className="cartoon-img">
              <Image attrImage={{ className: 'img-fluid', src: `${dashImg}`, alt: '' }} />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment >
  );
};
export default Greeting;